/**
 * Типы матчей для фильтра админского списка матчей. Идентификаторы общие для
 * клиента (кнопки фильтра) и сервера (условия выборки в GET /api/admin/matches),
 * поэтому лежат здесь, а не в самой странице.
 *
 * Типы взаимоисключающие, хотя в записи матча это отдельные флаги:
 *  - обучение помечено isTutorial и сохраняется с isLocal: false, isRanked: false,
 *    поэтому в «обычные сетевые» его надо не пустить явно;
 *  - локальные — isLocal;
 *  - обычные сетевые — все, что не рейтинговое, не локальное и не обучение;
 *  - рейтинговые — isRanked.
 */
export const MATCH_TYPE_FILTERS = {
  ALL: 'all',
  TUTORIAL: 'tutorial',
  LOCAL: 'local',
  CASUAL: 'casual',
  RANKED: 'ranked',
};

export const MATCH_TYPE_FILTER_OPTIONS = [
  {id: MATCH_TYPE_FILTERS.ALL, label: 'Все'},
  {id: MATCH_TYPE_FILTERS.TUTORIAL, label: 'Обучение'},
  {id: MATCH_TYPE_FILTERS.LOCAL, label: 'Локальные'},
  {id: MATCH_TYPE_FILTERS.CASUAL, label: 'Обычные'},
  {id: MATCH_TYPE_FILTERS.RANKED, label: 'Рейтинговые'},
];
